import moment from 'moment-timezone';

export const getTimesheetNavigator = (state) => {
  return state.timesheetNavigator;
};

export const getCurrentSelectedUserId = (state) => {
  const { currentSelectedUserId } = getTimesheetNavigator(state);
  return currentSelectedUserId;
};

export const getCurrentSelectedTimesheetDate = (state) => {
  const { currentSelectedTimesheetDate } = getTimesheetNavigator(state);
  return currentSelectedTimesheetDate;
};

export const getSelectTimeEntryDate = (state) => {
  const { selectedTimeEntryDate } = getTimesheetNavigator(state);
  return selectedTimeEntryDate;
};

export const getShowTerminatedUsers = (state) => {
  const { showTerminatedUsers } = getTimesheetNavigator(state);
  return showTerminatedUsers;
};

export const getSelectTimeEntryDateString = (state) => {
  const selectedTimeEntryDateString = getSelectTimeEntryDate(state);
  return moment(selectedTimeEntryDateString).format('YYYY-MM-DD');
};

export const getCurrentSelectedTimesheetDateString = (state) => {
  const currentTimesheetDate = getCurrentSelectedTimesheetDate(state);
  return moment(currentTimesheetDate).format('YYYY-MM-DD');
};

export const getDistrictId = (state) => {
  const { district } = getTimesheetNavigator(state);
  return (district) ? district.id : null;
};

export const getDepartmentId = (state) => {
  const { department } = getTimesheetNavigator(state);
  return (department) ? department.id : null;
};
